// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false ,
  firebase: {
    apiKey: "AIzaSyA04FmUAJVZx5lB6xjSkBKzhN-5Uh1y8ak",
    authDomain: "testapp-71134.firebaseapp.com",
    databaseURL: "https://testapp-71134-default-rtdb.firebaseio.com/",
    projectId: "testapp-71134",
   storageBucket: "testapp-71134.firebasestorage.app",
    messagingSenderId: "718476490644"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
